var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEkycFileAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.26825 16.8988H3.63188C2.60764 16.8988 1.77734 16.0685 1.77734 15.0443L1.77742 3.91703C1.77742 2.8928 2.60773 2.0625 3.63196 2.0625H11.9776C13.0019 2.0625 13.8322 2.89281 13.8322 3.91705V7.62614M5.02309 5.77159H10.5867M5.02309 8.55341H10.5867M10.5867 12.2269V14.5021C10.5867 15.6264 11.7855 16.6576 12.9098 16.6576C14.0341 16.6576 15.2231 15.6264 15.2231 14.5021V11.6282C15.2231 11.033 14.8809 10.4289 14.1198 10.4289C13.3055 10.4289 12.9098 11.033 12.9098 11.6282V14.3824M5.02309 11.3352H7.80491",
    stroke: "black",
    strokeWidth: 1.54545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEkycFileAttach);
export default __webpack_public_path__ + "static/media/ekyc-file-attach.db324b5befae9b6a989c4f407c9d0a57.svg";
export { ForwardRef as ReactComponent };